<template>
  <div>
    <PcPage v-if="isPc"></PcPage>
    <MobilePage v-else></MobilePage>
  </div>
</template>

<script>
import MobilePage from './mobile'
import PcPage from './pc'
import { deviceType } from '@/utils/common'
import { getHmToken } from '@/utils/hmToken'
import { ACCOUNT_TYPE } from '@/constant/common'
import { loginRoute, forgetPasswordRoute, createPasswordRoute } from './route'

const NOT_NEED_LOGIN_ROUTE = ['loginPage', 'forgetPasswordPage', 'createPasswordPage']

export default {
  components: {
    MobilePage,
    PcPage
  },
  data () {
    return {

    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    }
  },
  async created () {
    if (this.redirectPcPageToNewPage()) {
      return
    }
    await this.initData()
  },
  methods: {
    redirectPcPageToNewPage () {
      // pc端需要跳转到新页面去
      if (!deviceType.isPc) {
        return false
      }
      const currentPath = this.$route.path
      const basePath = `/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/`
      let path
      if (loginRoute.path === currentPath) {
        path = 'login'
      } else if (forgetPasswordRoute.path === currentPath) {
        path = 'forget-password'
      } else if (createPasswordRoute.meta === this.$route.meta) {
        const resetCode = this.$route.params.resetCode
        path = `create-password/${resetCode}`
      } else {
        return false
      }
      const back = this.$route.query.backUrl
      this.$router.push({ path: `${basePath}${path}`, query: { ...this.$route.query, back } })
      return true
    },
    async initData () {
      if (getHmToken() && !this.$route.query.logout) {
        if (this.$route.name === 'loginPage') {
          this.$router.push({ name: 'hm-dashboard', query: this.$route.query })
        }
      } else if (!getHmToken() && !NOT_NEED_LOGIN_ROUTE.includes(this.$route.name)) {
        if (deviceType.isPc) {
          this.$router.push({ path: `/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/login`, query: { ...this.$route.query, back: this.$route.fullPath } })
        } else {
          this.$router.push({ name: 'loginPage', query: { ...this.$route.query, backUrl: this.$route.fullPath } })
        }
      }
    }
  },
  watch: {
    $route () {
      this.redirectPcPageToNewPage()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
